import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import RCore from 'RCore';
import config from 'cfg';
import urllib from 'url';
import cx from 'classnames';
import { colorForTeam } from '../../helpers/TeamColorProfile';
import { SplitImageTPL, theme as splitSplitImageTPLTheme } from '../sm/templates/SplitImageTPL';
import { styledUI, getDisplayPropType } from '../sm/StyledUI';
import DropBackground from '../interactive/topScorersMulti/DropBackground';
import { StyleSheetManager } from 'styled-components';
import fetch from 'isomorphic-fetch';

const LOCAL_FONTS = require('../../fonts/index');

const CustomBGR = ({ editMode, areas = [], direction = 'row', border = false }) => {
    const p = (100 / areas.length).toFixed(1);
    const style = {};
    style[direction === 'row' ? 'width' : 'height'] = p + '%';

    return (
        <div style={{ display: 'flex', flexDirection: direction, height: '100%' }}>
            {areas.map((a, i) => {
                const CC = { ...style, flexGrow: 1 };

                CC[direction === 'row' ? 'border-right' : 'border-bottom'] =
                    i !== areas.length - 1 && border ? '4px solid #fff' : 'none';

                // CC[ ]
                return (
                    <DropBackground
                        id={a.key}
                        key={a.key}
                        style={CC}
                        url="https://talksport.com/wp-content/uploads/sites/5/2015/10/7drogba.jpg?strip=all&w=700"
                        editMode={editMode}
                        {...a}
                    />
                );
            })}
        </div>
    );
};

class SWTProvider extends React.Component {
    static defaultProps = {
        templateData: {},
    };

    constructor(props) {
        super(props);
        this.state = {};
    }

    static contextTypes = {
        info: PropTypes.object,
    };

    getTeamsColors = (theme, hasTeamColorLayer) => {
        const { teamIdColor } = this.props;
        const teamBackgroundColor = colorForTeam(teamIdColor, 'color', theme.primaryColor);
        const teamColor = colorForTeam(teamIdColor, 'stats', theme.primaryTextColor);

        const contentColors = {
            color: teamColor,
            titleColor: teamColor,
            subTitleColor: teamColor,
        };

        return Object.assign(
            {
                teamBackgroundColor,
                teamColor,
            },
            hasTeamColorLayer ? contentColors : {},
        );
    };

    getTheme = () => {
        const { userTheme, userTemplate, widgetTheme = {}, templateData, teamIdColor } = this.props;

        let theme = _.merge({}, splitSplitImageTPLTheme, (userTemplate || templateData).theme, widgetTheme, userTheme);
        let hasTeamColorLayer = false;

        const checkForTeamColor = l => l.backgroundImage.indexOf('isTeamColor=true') > -1;
        if (widgetTheme.layers && widgetTheme.layers.length) {
            hasTeamColorLayer = widgetTheme.layers.some(checkForTeamColor);
        } else if (theme.layers && theme.layers.length) {
            hasTeamColorLayer = theme.layers.some(checkForTeamColor);
        }
        const teamsColors = teamIdColor ? this.getTeamsColors(theme, hasTeamColorLayer) : {};
        theme = _.merge({}, theme, teamsColors);
        return theme;
    };

    renderTemplate = () => {
        var secondaryContent = this.props.children[0];
        var primaryContent = this.props.children[1];

        // console.log('SWT', this.props.);

        var customBGR = this.props.children[2];

        const areas = _.chain(this.props)
            .keys()
            .filter(k => k.indexOf('area') === 0 && this.props[k] && !_.isEmpty(this.props[k]))
            .map(key => ({ key, ...this.props[key] }))
            .compact()
            .value();

        if (!customBGR && areas.length > 0) {
            customBGR = <CustomBGR areas={areas} {...this.props.dnd} editMode={this.props.editMode} />;
        }

        const {
            template,
            swtPreviewCustomStyles = '',

            contentProps = {},
            secondaryContentProps = {},

            brandingPrimary,
            brandingSecondary,
            brandingAdditionalContent,
            screencast,
            branding,
            showCustomTitile = true,
            teamIdColor,
        } = this.props;

        switch (template) {
            default:
                return (
                    <SplitImageTPL
                        swtPreviewCustomStyles={swtPreviewCustomStyles}
                        previewLayer={this.props.previewLayer}
                        bgrLayer={this.props.bgrLayer}
                        background={customBGR}
                        theme={this.getTheme()}
                        titleImage={this.props.titleImage}
                        title={showCustomTitile ? this.props.title : null}
                        subTitle={this.props.subTitle}
                        secondaryContent={secondaryContent}
                        contentProps={contentProps}
                        secondaryContentProps={secondaryContentProps}
                        primaryContent={primaryContent}
                        screencast={screencast}
                        brandingPrimary={brandingPrimary}
                        brandingSecondary={brandingSecondary}
                        brandingAdditionalContent={brandingAdditionalContent}
                        brandingProps={branding}
                        widgetProps={this.props}
                        teamIdColor={teamIdColor}
                    />
                );
        }
    };

    render = () => {
        const theme = this.getTheme();
        const { fonts } = theme;

        if (this.props.children.length < 2) throw new Error('SWTProvider should have 2 children');

        const ssmId = '_widgetscope_';
        if (process.env.BROWSER && !document.getElementById(ssmId)) {
            var c = document.createElement('div');
            c.id = ssmId;
            window.document.head.appendChild(c);
        }
        return (
            <div className={this.props.widget}>
                <style
                    type="text/css"
                    key={'Flama'}
                    dangerouslySetInnerHTML={{
                        __html: LOCAL_FONTS['Flama'],
                    }}
                />
                <style
                    type="text/css"
                    key={'FuturaBold'}
                    dangerouslySetInnerHTML={{
                        __html: LOCAL_FONTS['FuturaBold'],
                    }}
                />

                <style
                    type="text/css"
                    key={'ProximaNova'}
                    dangerouslySetInnerHTML={{
                        __html: LOCAL_FONTS['ProximaNova'],
                    }}
                />

                {_.filter(Object.keys(fonts)).map(fontKey => {
                    const font = fonts[fontKey];
                    if (LOCAL_FONTS[font.gFontName]) {
                        return (
                            <style
                                type="text/css"
                                key={fontKey}
                                dangerouslySetInnerHTML={{
                                    __html: LOCAL_FONTS[font.gFontName],
                                }}
                            />
                        );
                    } else {
                        return (
                            font.gFontName &&
                            font.gWeights && (
                                <link
                                    rel="stylesheet"
                                    key={font.gFontName + '_' + fontKey}
                                    href={`https://fonts.googleapis.com/css?family=${font.gFontName}:${font.gWeights}`}
                                />
                            )
                        );
                    }
                })}

                {process.env.BROWSER && (
                    <StyleSheetManager target={document.getElementById(ssmId)}>
                        {this.renderTemplate()}
                    </StyleSheetManager>
                )}
                {!process.env.BROWSER && this.renderTemplate()}
            </div>
        );
    };
}

const mergeStyles = (theme, widgetId, variation) => {
    if (!widgetId) return theme;

    if (variation && variation !== 'default') {
        const widgetTheming = _.get(theme, `variations.${widgetId}.${variation}`, {});

        // Reflect.deleteProperty(theme, 'variations');
        Reflect.deleteProperty(theme, 'widgets');
        theme = _.merge(theme, widgetTheming);
        theme = { ...theme, layers: _.get(widgetTheming, 'layers', theme.layers) };

        return theme;
    }

    const widgetTheming = _.get(theme, `widgets.${widgetId}`, {});
    Reflect.deleteProperty(theme, 'widgets');

    theme = _.merge(theme, widgetTheming);
    theme = { ...theme, layers: _.get(widgetTheming, 'layers', theme.layers) };
    return theme;
};

const loadDataFunc = function (client, user, template, widgetId, variation) {
    return fetch(`${config.widgets.url}/api/clients/${client}/users/${user}/templates/${template}`)
        .then(response => response.json())
        .then(tpl => {
            tpl.theme = mergeStyles(tpl.theme, widgetId, variation);
            tpl.theme = _.merge({}, splitSplitImageTPLTheme, tpl.theme);
            return tpl;
        });
};

const loadData = function () {
    const { template, variation } = this.props;
    const { client, user } = this.context.info;
    if (this.props.tempTemplate) return Promise.resolve(this.props.tempTemplate);
    return loadDataFunc(client, user, template, _.get(this, 'constructor.spec.id'), variation);
};

const spec = (SWTProvider.spec = {
    propTypesNoTile: function () {
        return _.filter(this.propTypes, p => ['title', 'subTitle', 'titleDisplay'].indexOf(p.key) === -1);
    },
    // propTypesWithDefaults: function(defs) {
    //     let pt = this.propTypes
    //     Object.keys(defs).map(k => {
    //         let prop = pt.find(prop => prop.key == k);
    //         if (prop) prop.defaultValue = defs[k];
    //     })
    //     return pt;
    // },
    propTypes: [
        {
            key: 'template',
            type: 'template_picker',
            label: 'Templates',
            scope: 'template',
            ui: true,
        },
        {
            key: 'variation',
            type: 'textfield_picker',
            label: 'Template variation',
            scope: 'template',
            ui: true,
        },
        {
            key: 'title',
            label: 'Title',
            type: 'textfield_picker',
            scope: 'common',
            ui: true,
        },
        {
            key: 'subTitle',
            label: 'Sub title',
            type: 'textfield_picker',
            scope: 'common',
            ui: true,
        },
        {
            key: 'lang',
            type: 'select_picker',
            label: 'Language',
            scope: 'common',
            loader: true,
            options: [
                {
                    text: 'English',
                    value: 'en',
                },
                {
                    text: 'Danish',
                    value: 'da',
                },
                {
                    text: 'Swedish',
                    value: 'se',
                },
                {
                    text: 'Norwegian',
                    value: 'no',
                },
                {
                    text: 'Deutsch',
                    value: 'de',
                },
                {
                    text: 'Finish',
                    value: 'fi',
                },
                {
                    text: 'Thai',
                    value: 'th',
                },
                {
                    text: 'Chinise simpl',
                    value: 'sc',
                },
                {
                    text: 'Chinise trad',
                    value: 'tc',
                },
            ],
        },
        {
            key: 'tz',
            type: 'select_picker',
            label: 'Timezone',
            scope: 'common',
            loader: true,
            defaultValue: 'CET',
            options: [
                {
                    text: 'London',
                    value: 'Europe/London',
                },
                {
                    text: 'GMT',
                    value: 'GMT',
                },
                {
                    text: 'WET',
                    value: 'WET',
                },
                {
                    text: 'CET',
                    value: 'CET',
                },
                {
                    text: 'EEST',
                    value: 'eest',
                },
            ],
        },
        {
            key: 'wcwidth',
            type: 'select_picker',
            label: 'Widget width mode',
            scope: 'common',
            ui: true,
            defaultValue: 800,
            options: [
                {
                    text: 'Narrow (600)',
                    value: 600,
                },
                {
                    text: 'Standard (800)',
                    value: 800,
                },
                {
                    text: 'Wide (1024)',
                    value: 1024,
                },
                {
                    text: 'Full (1080)',
                    value: 1080,
                },
                {
                    text: 'XLarge (1200)',
                    value: 1200,
                },
            ],
        },
        {
            key: 'bgrLayer',
            label: 'Background Image',
            type: 'preview_image',
            ui: true,
            scope: 'images',
            depracated: true,
            props: {
                disableTopOverlay: true,
                default: {
                    scale: 1.0,
                    translateX: 0,
                    translateY: 0,
                    opacity: 1.0,
                    backgroundImage: null,
                    backgroundSize: 'cover',
                    backgroundPositionX: 'center',
                    backgroundPositionY: 'center',
                },
            },
        },
        {
            key: 'previewLayer',
            label: 'Preview Image',
            type: 'preview_image',
            ui: true,
            depracated: true,
            scope: 'images',
            props: {
                disableTopOverlay: true,
                default: {
                    scale: 1.0,
                    translateX: 0,
                    translateY: 0,
                    opacity: 1.0,
                    backgroundImage: null,
                    backgroundSize: 'contain',
                    backgroundPositionX: 'center',
                    backgroundPositionY: 'bottom',
                },
            },
        },
        {
            key: 'dnd',
            label: 'NEW Image Manipulations',
            type: 'dnd_bgr_picker',
            ui: true,
            props: {
                enabled: false,
                propsMap: {
                    area1: 'area1',
                    area2: 'area2',
                    area3: 'area3',
                    area4: 'area4',
                },
            },
        },

        getDisplayPropType('title', { ui: true }),
    ],
});

export { loadData, loadDataFunc, spec, SWTProvider };
export default SWTProvider;



/** WEBPACK FOOTER **
 ** ../src/widgets/components/core/SWTProvider.js
 **/